// 新規キャンバス作成時の初期名（URL クエリ ?name=）の読み出し。
//
// Connect Note の「新しいキャンバス」は、記事タイトルを引き継ぐために `/c/:canvasId?name=<タイトル>`
// を新規タブで開く。RC は未作成キャンバスの lazy create（bootstrap GET）時にこの name を初期
// キャンバス名として採用する（既存キャンバスを開くときは無視する）。
//
// 判定は同期関数として提供し、embed-mode.ts と同じく URLSearchParams で読み出す
// （このアプリは軽量な独自ルータで、クエリは各所で URLSearchParams で読む方針）。

/**
 * URL の search 文字列から ?name= を読み出す。未指定・空白のみは undefined を返す。
 * 実際の最大長クランプ・既定名フォールバックはサーバ（canvas-bootstrap）側で行う。
 */
export function readCreateCanvasNameFromUrl(search: string): string | undefined {
  const value = new URLSearchParams(search).get("name");
  if (value === null) return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}

/**
 * URL の search 文字列に name キーがあるか（値が空・空白だけでも true）。
 * 名前を指定して開いた新規キャンバスでは、初回の名前入力を出さない判定に使う（判定はサーバが行う）。
 */
export function hasCreateCanvasNameParam(search: string): boolean {
  return new URLSearchParams(search).has("name");
}
